import { TEAMS_SET_LOADING, TEAMS_SET_DATA, TEAMS_GET_ERROR } from 'src/actions/constants';

const defaultState = {
  teams: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case TEAMS_SET_LOADING: {
      return {
        ...state,
        isLoading: action.data,
      };
    }
    case TEAMS_SET_DATA: {
      return {
        ...state,
        teams: action.data,
      };
    }
    case TEAMS_GET_ERROR: {
      return {
        ...state,
        errorMessage: action.data,
      };
    }
    default: return state;
  }
};
